import { FormlyFieldConfigMap } from './formly-field-config.map';
import { FormlyUtil } from '../formly.util';
import { Attribute } from '@emm/core/models/attribute.model';
import {ItemAttributeType} from '@emm/core/models/enums';

const attributeFilterPlaceHolder = 'Search for an Item/Modifier';

export const itemAttributeFilterFieldMap: FormlyFieldConfigMap<Attribute> = {

    name: () => ({
        key: 'NAME',
        templateOptions: {
            label: 'Item Name',
            maxLength: 512,
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    tag: () => ({
        key: 'TAG',
        templateOptions: {
            label: 'Item Tag',
            maxLength: 512,
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    RMI: () => ({
        key: 'RMI',
        templateOptions: {
            label: 'RMI',
            maxLength: 512,
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    POS_ID: () => ({
        key: 'POS_ID',
        templateOptions: {
            label: 'POS ID',
            maxLength: 512,
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.Text]: (attribute: Attribute) => ({
        key: attribute.tag,
        templateOptions: {
            label: attribute.name,
            maxLength: 512,
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.TextArea]: (attribute: Attribute) => ({
        key: attribute.tag,
        templateOptions: {
            label: attribute.name,
            maxLength: 512,
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.Number]: (attribute: Attribute) => ({
        key: attribute.tag,
        templateOptions: {
            label: attribute.name,
            maxLength: 512,
            type: 'number',
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.Boolean]: (attribute: Attribute) => ({
        key: attribute.tag,
        templateOptions: {
            label: attribute.name,
            options: [...FormlyUtil.getBooleanList(true)]
        },
        type: 'select',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.Select]: (attribute: Attribute) => ({
        key: attribute.tag,
        templateOptions: {
            label: attribute.name,
            options: [...attribute.options],
            placeholder: attributeFilterPlaceHolder
        },
        type: 'select',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.MultiSelect]: (attribute: Attribute) => ({
        key: attribute.tag,
        templateOptions: {
            label: attribute.name,
            multiple: true,
            options: [...attribute.options],
            placeholder: attributeFilterPlaceHolder,
            selectAllOption: 'Select All'
        },
        type: 'select',
        wrappers: ['form-field-filter']
    }),

    [ItemAttributeType.Image]: (attribute: Attribute) => ({
        key: attribute.tag,
        templateOptions: {
            label: attribute.name,
            maxLength: 512,
            placeholder: attributeFilterPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
        })

};
